import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AliveScope } from "react-activation";
import App from "./App";
import RouterBridge from "./router/RouterBridge";
import { queryClient, queryKeys } from "./lib/queryClient";
import versionApi from "./api/mall/version";
import { appEnv } from "./config/env";
import { initDisablePageZoom } from "./utils/disablePageZoom";
import { initRem } from "./utils/rem";
import {
  bindInjectedTokenListener,
  bootstrapToken,
} from "./utils/token-bootstrap";
import { bootstrapUserInfo } from "./utils/user-bootstrap";
import { isPublicPagePath } from "./utils/is-public-page";
import "./index.scss";
import { Toast } from "antd-mobile";

const isPublicPage = isPublicPagePath();

Toast.config({ duration: 1500 });
document.title = appEnv.appTitle;
initRem();
initDisablePageZoom();

if (!isPublicPage) {
  bootstrapToken();
  bindInjectedTokenListener();
  void bootstrapUserInfo();
}

void queryClient.prefetchQuery({
  queryKey: queryKeys.versionCheck,
  queryFn: versionApi.loadVersionCheck,
});

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AliveScope>
        <RouterBridge>
          <App />
        </RouterBridge>
      </AliveScope>
    </BrowserRouter>
  </QueryClientProvider>,
);
